import { render, staticRenderFns } from "./order-list-filter.vue?vue&type=template&id=64fafb93&"
import script from "./order-list-filter.vue?vue&type=script&lang=js&"
export * from "./order-list-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports